/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable array-callback-return */
import Roboto from '../../../../../assets/fonts/Roboto-Bold.ttf'

import {
  Document,
  Font,
  Image,
  Image as PDFImage,
  Page,
  Path,
  StyleSheet,
  Svg,
  Text,
  View
} from '@react-pdf/renderer'
import { IDadoGrafico2, iLinhaTabelaAvaliacoes, iResultadoIndividualIndicativa, iSelo } from '../..'
import { ArrayToChunks, GroupBy, PropInvalida } from '../../../../../Utils/Helper'
import { parseJwt } from '../../../../../services/token'
import { Footer } from './Components/Footer'
import { Header } from './Components/Header'

interface iProps {
  model: iResultadoIndividualIndicativa
  Grafico?: string
  GraficoDados: IDadoGrafico2[]
}

export const RelatorioPDF: React.FC<iProps> = ({
  model,
  Grafico,
  GraficoDados
}) => {
  const urlDefault = 'https://sigah.blob.core.windows.net/assets/icones/Icones-SISTEMA-25.png'
  const valorOrdenado = [...GraficoDados].sort((a, b) => parseFloat(b.media) - parseFloat(a.media))
  const isCobb = parseJwt().eid === process.env.REACT_APP_COBB_EMPRESA_ID

  function ObterNomeParticipante(tipo: number): string {
    if (tipo === 0) {
      return 'Autoavaliação'
    } else if (tipo === 1) {
      return 'Gestor'
    } else if (tipo === 2) {
      return 'Par'
    } else if (tipo === 3) {
      return 'Liderado'
    } else if (tipo === 4) {
      return 'Outro'
    } else if (tipo === 6) {
      return 'Alta liderança'
    }
    return 'Não identificado'
  }

  const MostrarIntroducao = model.introducaoAvaliacao !== false
  const MostrarEstrutura = model.avaliadoresEscala !== false
  const MostrarCompetencias = model.competencias.length > 0
  const MostrarRecomendacoes = model.recomendacoesIa !== false && (model.acoes?.length ?? 0) > 0

  // numeração do sumário e dos rodapés: cada página opcional que não sai desloca as seguintes
  const PaginasOcultas = [
    { pagina: 2, oculta: !MostrarIntroducao },
    { pagina: 3, oculta: !MostrarEstrutura },
    { pagina: 4, oculta: !MostrarCompetencias },
    { pagina: 7, oculta: model.discursivas.length === 0 || !model.comentariosRelatorio },
    { pagina: 8, oculta: model.resumoCompetencias.length === 0 },
    { pagina: 9, oculta: model.resumoCompetencias.length === 0 },
    { pagina: 10, oculta: !MostrarRecomendacoes },
    { pagina: 11, oculta: !MostrarRecomendacoes || (model.acoes?.length ?? 0) <= 3 }
  ]

  function GetPage(page: number): number {
    return page - PaginasOcultas.filter(e => e.pagina < page && e.oculta).length
  }

  // icone vazio ou quebrado derruba a renderizacao inteira do documento
  function ObterIcone(icone?: string): string {
    if (PropInvalida(icone)) {
      return urlDefault
    }
    return (icone as string).replace('Competencias-', 'Icones-SISTEMA-').replace('svg', 'png')
  }

  function TemEixo(tipo: number): boolean {
    return model.tabelaAvaliacoes2.some(e => e.selos2?.some(r => r.stake === tipo))
  }

  function ObterLogo(): string {
    const logo = localStorage.getItem('logo') ?? ''
    if (PropInvalida(logo)) {
      return 'https://sigah.blob.core.windows.net/onboard/f99445d7-d98d-48ad-9cdb-a443a9f636a2.png'
    }

    if (logo.includes('https://blob-hml.icecloud.com.br') || logo.includes('https://blob.icecloud.com.br')) {
      return logo.replace('https://blob-hml.icecloud.com.br', 'https://sigah.blob.core.windows.net/sigah').replace('https://blob.icecloud.com.br', 'https://sigah.blob.core.windows.net/sigah')
    } else if (logo?.includes('https://sigah.arquiteturahumana.com.br')) {
      return logo.replace('https://sigah.arquiteturahumana.com.br', 'https://sigah.blob.core.windows.net/sigah')
    }
    return logo
  }

  Font.register({
    family: 'Roboto',
    fonts: [{
      src: Roboto
    }]
  })

  const styles = StyleSheet.create({
    DefaultPage: {
      flexDirection: 'column',
      paddingBottom: '32px',
      justifyContent: 'space-between'
    },
    Sumario: {
      backgroundColor: '#1961E0',
      flexDirection: 'column',
      justifyContent: 'center',
      color: 'white',
      padding: 32
    },
    table: {
      display: 'flex',
      width: 'auto'
    },
    tableRow: {
      margin: 'auto',
      width: '100%',
      flexDirection: 'row'
    },
    tableRow2: {
      margin: 'auto',
      width: '100%',
      flexDirection: 'row',
      backgroundColor: '#F0F0F0'
    },
    tableCol: {
      fontFamily: 'Roboto',
      fontWeight: 'bold'
    },
    tableHeaderCol: {
      color: 'black'
    },
    tableCell: {
      margin: 'auto',
      fontSize: 10,
      padding: 5,
      fontFamily: 'Roboto',
      fontWeight: 'bold',
      textAlign: 'center',
      minHeight: '26px',
      maxHeight: '26px',
      width: '100%'
    },
    pageBackground: {
      position: 'absolute',
      minWidth: '100vw',
      minHeight: '100vh',
      height: '100vw',
      width: '100vh',
      zIndex: 0
    }
  })

  function ObterIcone2(obj: iSelo): any {
    if (obj.selo === 4) {
      return <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <Path d="M0.500178 0H4.50008C4.6657 0 4.82195 0.084375 4.9157 0.221875L7.45001 4.02187C5.90318 4.15 4.51258 4.82187 3.46261 5.84375L0.0845632 0.778125C-0.0185593 0.625 -0.0279341 0.428125 0.0595638 0.265625C0.147062 0.103125 0.315808 0 0.500178 0ZM15.9154 0.778125L12.5374 5.84688C11.4905 4.825 10.0968 4.15313 8.54999 4.025L11.0843 0.221875C11.178 0.08125 11.3343 0 11.4999 0H15.4998C15.6842 0 15.8529 0.1 15.9404 0.265625C16.0279 0.43125 16.0186 0.625 15.9154 0.778125ZM13.4999 10.5C13.4999 13.5375 11.0374 16 8 16C4.96257 16 2.50013 13.5375 2.50013 10.5C2.50013 7.4625 4.96257 5 8 5C11.0374 5 13.4999 7.4625 13.4999 10.5ZM8.26249 7.53438C8.15625 7.31563 7.84688 7.31563 7.73751 7.53438L7.03752 8.95312C6.99377 9.04062 6.91253 9.1 6.81878 9.1125L5.25007 9.34062C5.00945 9.375 4.9157 9.66875 5.08757 9.84062L6.22192 10.9469C6.29067 11.0156 6.32192 11.1094 6.30629 11.2063L6.03755 12.7656C5.99692 13.0031 6.24692 13.1875 6.46254 13.075L7.8625 12.3375C7.94688 12.2937 8.05 12.2937 8.13437 12.3375L9.53434 13.075C9.74996 13.1875 9.99995 13.0062 9.95933 12.7656L9.69059 11.2063C9.67496 11.1125 9.70621 11.0156 9.77496 10.9469L10.9093 9.84062C11.0843 9.67187 10.9874 9.37812 10.7468 9.34062L9.18122 9.1125C9.08747 9.1 9.0031 9.0375 8.96248 8.95312L8.26249 7.53438Z" fill="#27AE60"/>
      </Svg>
    } else if (obj.selo === 1) {
      return <Svg width="16" height="17" viewBox="0 0 16 17" fill="none">
        <Path d="M2.457 0.656678C2.16014 0.425441 1.73829 0.453564 1.46955 0.719175L0.219623 1.96911C-0.0459869 2.23472 -0.0741103 2.65657 0.154002 2.95655L2.65386 6.20637C2.79448 6.39074 3.01634 6.5001 3.24758 6.5001H4.93811L8.34417 9.90617C7.88482 10.8124 8.03169 11.9498 8.79102 12.706L12.2908 16.2058C12.6814 16.5964 13.3158 16.5964 13.7064 16.2058L15.7063 14.2059C16.0969 13.8153 16.0969 13.181 15.7063 12.7904L12.2065 9.29057C11.4503 8.53437 10.3128 8.38438 9.40662 8.84372L6.00055 5.43766V3.75026C6.00055 3.51589 5.89118 3.29716 5.70682 3.15654L2.457 0.656678ZM0.622726 12.8779C0.225873 13.2747 0.000885511 13.8153 0.000885511 14.3778C0.000885511 15.5496 0.950833 16.4996 2.12264 16.4996C2.68511 16.4996 3.22571 16.2746 3.62256 15.8777L7.30361 12.1967C7.05987 11.5436 7.02237 10.8342 7.19111 10.1624L5.26309 8.23438L0.622726 12.8779ZM16 5.00019C16 4.67208 15.9656 4.35335 15.9 4.04712C15.825 3.69713 15.3969 3.60651 15.1438 3.85963L13.147 5.85639C13.0533 5.95013 12.9252 6.00326 12.7939 6.00326H11.0003C10.7253 6.00326 10.5003 5.77827 10.5003 5.50328V3.70651C10.5003 3.57527 10.5534 3.44715 10.6472 3.3534L12.6439 1.35664C12.897 1.10353 12.8064 0.675427 12.4564 0.600431C12.1471 0.53481 11.8284 0.500437 11.5002 0.500437C9.01601 0.500437 7.0005 2.51595 7.0005 5.00019V5.02519L9.66598 7.69066C10.7909 7.4063 12.0346 7.70629 12.9158 8.58749L13.4064 9.07809C14.9376 8.35938 16 6.80321 16 5.00019ZM3.25071 13.9997C3.25071 14.4153 2.91635 14.7496 2.50075 14.7496C2.08515 14.7496 1.75079 14.4153 1.75079 13.9997C1.75079 13.5841 2.08515 13.2497 2.50075 13.2497C2.91635 13.2497 3.25071 13.5841 3.25071 13.9997Z" fill="#F2994A"/>
      </Svg>
    } else if (obj.selo === 2) {
      return <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <Path d="M1.4875 10.0474L7.13438 16.212C7.36875 16.4678 7.67812 16.6104 8 16.6104C8.32188 16.6104 8.63125 16.4678 8.86563 16.212L14.5125 10.0474C15.4625 9.01321 16 7.56248 16 6.04598V5.83404C16 3.27973 14.4219 1.10181 12.2688 0.681576C10.8438 0.403855 9.39375 0.948335 8.375 2.13961L8 2.57812L7.625 2.13961C6.60625 0.948335 5.15625 0.403855 3.73125 0.681576C1.57812 1.10181 0 3.27973 0 5.83404V6.04598C0 7.56248 0.5375 9.01321 1.4875 10.0474Z" fill="#2F80ED"/>
        </Svg>
    } else if (obj.selo === 3) {
      return <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <Path d="M8 16C12.4187 16 16 12.4187 16 8C16 3.58125 12.4187 0 8 0C3.58125 0 0 3.58125 0 8C0 12.4187 3.58125 16 8 16ZM4.97813 12.1469C4.89688 12.4094 4.61563 12.5594 4.35313 12.475C4.09063 12.3906 3.94063 12.1125 4.025 11.85C4.5375 10.1906 6.13437 9 8 9C9.86563 9 11.4625 10.1906 11.9781 11.8531C12.0594 12.1156 11.9125 12.3969 11.65 12.4781C11.3875 12.5594 11.1062 12.4125 11.025 12.15C10.6406 10.9187 9.44062 10 8 10C6.55938 10 5.35938 10.9188 4.97813 12.1469ZM6.5125 6.5C6.5125 7.05313 6.06562 7.5 5.5125 7.5C4.95937 7.5 4.5125 7.05313 4.5125 6.5C4.5125 5.94687 4.95937 5.5 5.5125 5.5C6.06562 5.5 6.5125 5.94687 6.5125 6.5ZM10.5125 7.5C9.95937 7.5 9.5125 7.05313 9.5125 6.5C9.5125 5.94687 9.95937 5.5 10.5125 5.5C11.0656 5.5 11.5125 5.94687 11.5125 6.5C11.5125 7.05313 11.0656 7.5 10.5125 7.5Z" fill="#66046B"/>
      </Svg>
    } else {
      return <></>
    }
  }

  function RenderizarBloco(e: iLinhaTabelaAvaliacoes, stake: number): any {
    return (
    <View style={{ ...styles.tableCell, borderRight: '2px solid #D6D6D6' }}>
      <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
        {GroupBy(e.selos2.filter(e => e.stake === stake), (r) => r.selo).toList().map((a, i) => {
          return (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }} key={i}>
                <Text>{a.data.length > 1 ? a.data.length : ''}</Text>
                {ObterIcone2(a.data[0])}
            </div>
          )
        })}
      </div>
    </View>
    )
  }

  function RetornarTabela(): any {
    return (<View style={styles.table}>
      <View style={styles.tableHeaderCol}>
          <View style={styles.tableRow}>
              <Text style={{ ...styles.tableCell, width: '1000px', textAlign: 'left', paddingLeft: '16px' }}>Competências</Text>
              {TemEixo(0) && (<Text style={styles.tableCell}>Autoavaliação</Text>)}
              {TemEixo(1) && (<Text style={styles.tableCell}>Gestor</Text>)}
              {TemEixo(2) && (<Text style={styles.tableCell}>Pares</Text>)}
              {TemEixo(3) && (<Text style={styles.tableCell}>Liderados</Text>)}
              {TemEixo(4) && (<Text style={styles.tableCell}>Outros</Text>)}
              {TemEixo(6) && (<Text style={styles.tableCell}>Alta Liderança</Text>)}
          </View>
      </View>
      <View>
          {model.tabelaAvaliacoes2.map((e, i) => {
            return (
                  <View style={i % 2 === 0 ? styles.tableRow2 : styles.tableRow} key={i}>
                      <Text style={{ ...styles.tableCell, width: '1000px', textAlign: 'left', borderLeft: '2px solid #D6D6D6', borderRight: '2px solid #D6D6D6', paddingLeft: '16px' }}>{e.competencia}</Text>
                      {TemEixo(0) && (
                        RenderizarBloco(e, 0)
                      )}

                      {TemEixo(1) && (
                        RenderizarBloco(e, 1)
                      )}

                      {TemEixo(2) && (
                        RenderizarBloco(e, 2)
                      )}

                      {TemEixo(3) && (
                        RenderizarBloco(e, 3)
                      )}

                      {TemEixo(4) && (
                        RenderizarBloco(e, 4)
                      )}

                      {TemEixo(6) && (
                        RenderizarBloco(e, 6)
                      )}

                  </View>
            )
          })}

      </View>
  </View>)
  }

  Font.registerHyphenationCallback((e) => {
    if (e.includes('http') && e.length > 100) {
      const arr: string[] = []
      for (let i = 0; i < e.length; i += 100) {
        arr.push(e.substring(i, i + 100))
      }
      return arr
    }

    if (e.includes('Flexibilidade/Adaptabilidade')) {
      return e.split('/')
    }

    if (e.includes('Autodesenvolvimento')) {
      return ['Autodesenvolvi', 'mento']
    }

    if (e.length === 1) {
      return [e, '']
    }
    return [e]
  })

  // function GerarTabela(): iLinhaTabela[][] {
  //   const tabela2 = [...tabela]
  //   const linhas: iLinhaTabelaAvaliacoes[] = []
  //   tabela2.forEach((e) => {
  //     linhas.push(e)
  //     if (e.questoes.length > 1) {
  //       e.questoes.forEach((q, i2) => {
  //         linhas.push({
  //           idQuestao: '',
  //           competencia: `${e.competencia} ${(1 + i2)} >_<`,
  //           autoAvaliacao: q.autoAvaliacao,
  //           mediaSemAuto: q.mediaSemAuto,
  //           altalideranca: q.altalideranca,
  //           gestor: q.gestor,
  //           liderados: q.liderados,
  //           outros: q.outros,
  //           pares: q.pares,
  //           questoes: [],
  //           pergunta: q.pergunta
  //         })
  //       })
  //     }
  //   })

  //   linhas.push({
  //     idQuestao: '',
  //     competencia: 'Média geral',
  //     autoAvaliacao: Medias[0].mediaAutoAval.toFixed(2),
  //     mediaSemAuto: Medias[0].mediaSemAuto.toFixed(2),
  //     altalideranca: Medias[0].mediaAltaLideranca.toFixed(2),
  //     gestor: Medias[0].mediaGestor.toFixed(2),
  //     liderados: Medias[0].mediaLiderados.toFixed(2),
  //     outros: Medias[0].mediaOutros.toFixed(2),
  //     pares: Medias[0].mediaPares.toFixed(2),
  //     questoes: []
  //   })
  //   return ArrayToChunks(linhas, calcularChunk())
  // }

  // function calcularChunk(): number {
  //   let arrayToChunkLimit = 0
  //   model.pdf?.competencias.forEach((e) => {
  //     if ((model.graficoHierarquia?.dados.length ?? 0) < 4) {
  //       if (e.nome.length < 22) {
  //         arrayToChunkLimit = (arrayToChunkLimit + 2.5)
  //       } else if (e.nome.length < 44) {
  //         arrayToChunkLimit = (arrayToChunkLimit + 1.3)
  //       } else {
  //         arrayToChunkLimit = (arrayToChunkLimit + 1)
  //       }
  //     }
  //     e.questoes.forEach((a) => {
  //       if ((model.graficoHierarquia?.dados.length ?? 0) >= 4) {
  //         if (e.nome.length < 22) {
  //           arrayToChunkLimit = (arrayToChunkLimit + 2.5)
  //         } else if (e.nome.length < 44) {
  //           arrayToChunkLimit = (arrayToChunkLimit + 1.3)
  //         } else {
  //           arrayToChunkLimit = (arrayToChunkLimit + 1)
  //         }
  //       }
  //     })
  //     if ((model.graficoHierarquia?.dados.length ?? 0) >= 4) {
  //       if (e.nome.length < 22) {
  //         arrayToChunkLimit = (arrayToChunkLimit + 1.5)
  //       } else if (e.nome.length < 44) {
  //         arrayToChunkLimit = (arrayToChunkLimit + 0.75)
  //       } else {
  //         arrayToChunkLimit = (arrayToChunkLimit + 0.3)
  //       }
  //     }
  //     e.questoes.forEach((a) => {
  //       if ((model.graficoHierarquia?.dados.length ?? 0) >= 4) {
  //         if (e.nome.length < 22) {
  //           arrayToChunkLimit = (arrayToChunkLimit + 1.5)
  //         } else if (e.nome.length < 44) {
  //           arrayToChunkLimit = (arrayToChunkLimit + 0.75)
  //         } else {
  //           arrayToChunkLimit = (arrayToChunkLimit + 0.3)
  //         }
  //       }
  //     })
  //   })
  //   if (((model.pdf?.competencias?.length ?? 0) < arrayToChunkLimit * 0.2)) {
  //     return 6
  //   } else if ((model.pdf?.competencias?.length ?? 0) < arrayToChunkLimit * 0.3) {
  //     return 9
  //   } else if ((model.pdf?.competencias?.length ?? 0) < arrayToChunkLimit * 0.4) {
  //     return 11
  //   } else {
  //     return 13
  //   }
  // }

  return (
    <Document>
      <Page>
        <View style={{ color: '#FFFFFF' }}>
          <View style={{ margin: '48px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-end' }}>
            <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
              <PDFImage src={'https://sigah.blob.core.windows.net/onboard/icones/logo_ah_b2 1 %281%29_e1ec7847-20dc-4eb5-8bae-635820a010d4.png'} style={{ width: '131px', maxHeight: '50px', marginBottom: '22px' }}/>
              <Text style={{ maxWidth: '440px', fontSize: '36px', fontFamily: 'Roboto', textAlign: 'right', fontWeight: 'bold', top: 0 }}>{model.nomePesquisa}</Text>
              <Text style={{ maxWidth: '440px', fontSize: '28px', textAlign: 'right' }}>{model.avaliado.nome}</Text>
            </View>
          </View>
        <View
            style={{
              height: 140,
              width: 160,
              right: -380,
              top: 380,
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <View style={{
              height: 105,
              width: 120,
              justifyContent: 'center',
              alignItems: 'center'
            }}
            >
              {
                (localStorage.getItem('logo') !== undefined) && (
                  <PDFImage
                  style={{ objectFit: 'contain', width: '170px', maxHeight: '170px' }}
                  src={ObterLogo()}
                />
                )
              }
            </View>
          </View>
          <PDFImage style={{ zIndex: 1, position: 'absolute', top: 0, height: '100vh', width: '100vw' }} src={'https://sigah.blob.core.windows.net/onboard/icones/Capa %289%29_ea8b2563-0a74-48d7-ba09-3097b4f531dc.png'}/>
        </View>
      </Page>

      <Page style={styles.Sumario}>
        <View style={{ flex: 1, justifyContent: 'center' }}>
          <View style={{ display: 'flex', alignSelf: 'center', justifyContent: 'center', marginBottom: '72px' }}>
            <Text
              style={{
                textAlign: 'center',
                fontSize: 32,
                fontFamily: 'Roboto',
                fontWeight: 'bold',
                marginBottom: '28px',
                paddingBottom: '4px',
                borderBottom: '3px solid black',
                maxWidth: '120px'
              }}
            >
              Sumário
            </Text>
          </View>
          <View style={{ display: 'flex', gap: '16px', fontSize: 24, justifyContent: 'center' }}>
            {MostrarIntroducao && <View style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center', paddingLeft: 32 }}>
              <Text style={{ fontSize: 32 }}>0{GetPage(2)}</Text>
              <View style={{ width: '24px', height: '3px', backgroundColor: 'black' }}></View>
              <Text>Introdução</Text>
            </View>}
            {MostrarEstrutura && <View style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center', paddingLeft: 32 }}>
              <Text style={{ fontSize: 32 }}>0{GetPage(3)}</Text>
              <View style={{ width: '24px', height: '3px', backgroundColor: 'black' }}></View>
              <Text>Estrutura da pesquisa</Text>
            </View>}
            {MostrarCompetencias && <View style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center', paddingLeft: 32 }}>
              <Text style={{ fontSize: 32 }}>0{GetPage(4)}</Text>
              <View style={{ width: '24px', height: '3px', backgroundColor: 'black' }}></View>
              <Text>Competências utilizadas</Text>
            </View>}
            <View style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center', paddingLeft: 32 }}>
              <Text style={{ fontSize: 32 }}>0{GetPage(5)}</Text>
              <View style={{ width: '24px', height: '3px', backgroundColor: 'black' }}></View>
              <Text>Resultados</Text>
            </View>
            {model.discursivas.length > 0 && model.comentariosRelatorio && <View style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center', paddingLeft: 32 }}>
              <Text style={{ fontSize: 32 }}>0{GetPage(7)}</Text>
              <View style={{ width: '24px', height: '3px', backgroundColor: 'black' }}></View>
              <Text>Comentários</Text>
            </View>}
            <View style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center', paddingLeft: 32 }}>
              <Text style={{ fontSize: 32 }}>0{GetPage(8)}</Text>
              <View style={{ width: '24px', height: '3px', backgroundColor: 'black' }}></View>
              <Text>Conclusões</Text>
            </View>
            {MostrarRecomendacoes && <View style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center', paddingLeft: 32 }}>
              <Text style={{ fontSize: 32 }}>{GetPage(10) < 10 ? 0 : ''}{GetPage(10)}</Text>
              <View style={{ width: '24px', height: '3px', backgroundColor: 'black' }}></View>
              <Text>Recomendações</Text>
            </View>}
          </View>
        </View>
        <Footer sumario nomeAvaliado={model.avaliado.nome} nomePesquisa={model.nomePesquisa}/>
      </Page>

      {MostrarIntroducao && <Page style={styles.DefaultPage}>
        <Header />
        <View>
          <View style={{ display: 'flex', justifyContent: 'center', padding: 32, paddingBottom: 16 }}>
            <Text
              style={{
                textAlign: 'center',
                fontSize: 24,
                fontFamily: 'Roboto',
                fontWeight: 'bold',
                paddingBottom: '32px',
                color: '#000000'
              }}
            >
              Introdução
            </Text>

            <View>
              <Text style={{ fontSize: 12, marginBottom: '24px' }}>
              Você está recebendo o seu relatório individual da Pesquisa 360° Indicativa com os resultados baseados na percepção dos stakeholders em relação as suas competências.
              </Text>
            </View>
            <div style={{ display: 'flex', gap: '16px', flexDirection: 'row', flexWrap: 'nowrap', marginBottom: '24px', alignItems: 'center' }}>
              <View style={{ width: '17%' }}>
                <Image
                  style={{ height: '80px', width: '80px' }}
                  src={'https://sigah.blob.core.windows.net/onboard/icones/Group 4 %285%29_0821dabf-286c-49f2-9efe-525fc6144590.png'}
                />
              </View>
              <View style={{ width: '100%', paddingLeft: 16, paddingRight: 16 }}>
                <Text style={{ fontSize: 16, marginBottom: '4px' }}>
                  O que é a Pesquisa 360° Indicativa?
                </Text>
                <Text style={{ fontSize: 11, textAlign: 'justify' }}>
                  Pesquisa de percepção dos stakeholders sobre suas competências, fornecendo informações importantes para seu crescimento profissional. Você será capaz de identificar, entre suas competências, quais são destaques positivos e quais devem ser priorizadas em seu desenvolvimento individual. Nessa pesquisa os Stakeholders, com base nas competências da empresa, selecionam um numero determinado como destaques positivos e como potenciais para desenvolvimento.
                </Text>
              </View>
            </div>
            <div style={{ display: 'flex', gap: '16px', flexDirection: 'row', flexWrap: 'nowrap', marginBottom: '24px', alignItems: 'center' }}>
              <View style={{ width: '17%' }}>
                <Image
                  style={{ height: '80px', width: '80px' }}
                  src={'https://sigah.blob.core.windows.net/onboard/f776947a-1430-4de3-9823-0cc37d8db337.png'}
                />
              </View>
              <View style={{ width: '100%', paddingLeft: 16, paddingRight: 32, fontSize: '11px' }}>
                <Text style={{ fontSize: 16, marginBottom: '4px' }}>
                  O que você encontrará neste relatório:
                </Text>
                <div style={{ display: 'flex', flexDirection: 'column', fontSize: 11, textAlign: 'justify' }}>
                  <View style={{ flexDirection: 'row', marginBottom: 4 }}>
                    <Text style={{ marginHorizontal: 8 }}>•</Text>
                    <Text>Identificação das competências destacadas como seus diferenciais na posição atual.</Text>
                  </View>
                  <View style={{ flexDirection: 'row', marginBottom: 4 }}>
                    <Text style={{ marginHorizontal: 8 }}>•</Text>
                    <Text>Identificação das competências a serem priorizadas para desenvolvimento, de acordo com a percepção de seus stakeholders.</Text>
                  </View>
                  <View style={{ flexDirection: 'row', marginBottom: 4 }}>
                    <Text style={{ marginHorizontal: 8 }}>•</Text>
                    <Text>Recomendações para o seu desenvolvimento, com sugestões de como você pode desenvolver as competências priorizadas.</Text>
                  </View>
                </div>
              </View>
            </div>
            <div style={{ display: 'flex', gap: '16px', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center' }}>
              <View style={{ width: '17%' }}>
                <Image
                  style={{ height: '80px', width: '80px' }}
                  src={'https://sigah.blob.core.windows.net/onboard/c515809b-81dc-450a-8992-e20477b7e75f.png'}
                />
              </View>
              <View style={{ width: '100%', paddingLeft: 16, paddingRight: 32 }}>
                <Text style={{ fontSize: 16, marginBottom: '4px' }}>
                O que devo fazer depois de receber esse relatório?
                </Text>
                <div style={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap', fontSize: '11px', textAlign: 'justify' }}>
                  <View style={{ flexDirection: 'row', marginBottom: 4 }}>
                    <Text style={{ marginHorizontal: 8 }}>1.</Text>
                    <Text>Leia o relatório com atenção, refletindo sobre as informações apresentadas.</Text>
                  </View>
                  <View style={{ flexDirection: 'row', marginBottom: 4 }}>
                    <Text style={{ marginHorizontal: 8 }}>2.</Text>
                    <Text>Agende uma conversa com seu gestor para discutir os resultados da pesquisa. Juntos, vocês poderão analisar seus pontos fortes e potenciais de melhoria, assim como explorá-los ainda mais, além de definir estratégias para superar os desafios identificados e construir um plano de ação personalizado.</Text>
                  </View>
                  <View style={{ flexDirection: 'row', marginBottom: 4 }}>
                    <Text style={{ marginHorizontal: 8 }}>3.</Text>
                    <Text>Utilize este relatório como um guia para o seu desenvolvimento profissional contínuo. Busque oportunidades de aprendizado e crescimento, participe de treinamentos e workshops, e esteja sempre aberto a novos desafios.</Text>
                  </View>
                </div>
              </View>
            </div>
          </View>
        </View>

        <View>
          <View
            style={{
              width: '100%',
              backgroundColor: '#1961E0',
              flexDirection: 'row',
              color: 'white',
              padding: 16,
              paddingHorizontal: 32,
              alignItems: 'center'
            }}
          >
            <View
              style={{
                flexDirection: 'column',
                width: '100%',
                textAlign: 'right'
              }}
            >
              <Text
                style={{ fontFamily: 'Roboto', fontWeight: 'bold', fontSize: 16, marginBottom: 4 }}
              >
                Dicas de ouro
              </Text>
              <Text style={{ fontSize: 12 }}>
              Receber feedbacks é um presente para o seu desenvolvimento, tenha gratidão a
              todos que se dedicaram à sua pesquisa. Pratique o positivismo! Orgulhe-se das competências destacadas positivamente e reflita sobre como mantê-las e fortalece-las ainda mais. Não se prenda apenas aos seus pontos de desenvolvimento, valorize seus pontos fortes!
              </Text>
            </View>
            <View style={{ marginLeft: 8 }}>
              <PDFImage
                style={{ width: '91px', objectFit: 'contain' }}
                src={'https://sigah.blob.core.windows.net/onboard/icones/Trofeu com fundo %282%29_8a3b3643-e4c3-47ce-9d23-dfdcb452966f.png'}
              />

            </View>
          </View>
        </View>
        <Footer nomeAvaliado={model.avaliado.nome} nomePesquisa={model.nomePesquisa} numeroPagina={GetPage(2)}/>
      </Page>}

      {MostrarEstrutura && <Page style={styles.DefaultPage}>
        <Header />
        <View style={{ paddingHorizontal: 32, paddingVertical: 24, flex: 1 }}>
          <View style={{ display: 'flex', justifyContent: 'center' }}>
            <Text
              style={{
                textAlign: 'center',
                fontSize: 24,
                fontFamily: 'Roboto',
                fontWeight: 'bold',
                paddingBottom: '32px',
                color: '#000000'
              }}
            >
              Estrutura da pesquisa
            </Text>
          </View>
          <View style={{ display: 'flex' }}>
            <Text
              style={{
                textAlign: 'left',
                fontSize: 16,
                fontFamily: 'Roboto',
                fontWeight: 'bold',
                paddingBottom: '12px',
                color: '#000000'
              }}
            >
              Vertentes de Stakeholders
            </Text>
            <View style={{ paddingHorizontal: 16, display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {model.participantes.some(e => e === 0) && <div style={{ display: 'flex', flexWrap: 'nowrap', flexDirection: 'row', fontSize: 14, alignItems: 'center', gap: '8px' }}>
                <Svg width="24" height="20" viewBox="0 0 24 20" fill="none">
                  <Path d="M8.4 10C11.0512 10 13.2 7.85127 13.2 5.20002C13.2 2.54877 11.0512 0.400024 8.4 0.400024C5.74875 0.400024 3.6 2.54877 3.6 5.20002C3.6 7.85127 5.74875 10 8.4 10ZM11.76 11.2H11.1337C10.3012 11.5825 9.375 11.8 8.4 11.8C7.425 11.8 6.5025 11.5825 5.66625 11.2H5.04C2.2575 11.2 0 13.4575 0 16.24V17.8C0 18.7938 0.80625 19.6 1.8 19.6H15C15.9937 19.6 16.8 18.7938 16.8 17.8V16.24C16.8 13.4575 14.5425 11.2 11.76 11.2ZM23.8725 6.38503L22.83 5.33127C22.6575 5.15502 22.3762 5.15502 22.2 5.32752L18.27 9.22752L16.5637 7.51003C16.3912 7.33378 16.11 7.33377 15.9337 7.50627L14.88 8.55252C14.7037 8.72502 14.7037 9.00627 14.8762 9.18252L17.94 12.2688C18.1125 12.445 18.3937 12.445 18.57 12.2725L23.8687 7.01502C24.0412 6.83877 24.045 6.55752 23.8725 6.38503Z" fill="black"/>
                </Svg>
                <div>
                  <Text style={{ fontSize: 14, marginBottom: '2px' }}>Autoavaliação</Text>
                  <Text style={{ fontSize: 10 }}>Análise das competências pelo próprio AVALIADO.</Text>
                </div>
              </div>}

              {model.participantes.some(e => e === 1) && <div style={{ display: 'flex', flexWrap: 'nowrap', flexDirection: 'row', fontSize: 14, alignItems: 'center', gap: '8px' }}>
                <Svg width="20" height="22" viewBox="0 0 20 22" fill="none">
                  <Path d="M10.0001 10.8359C12.9459 10.8359 15.3334 8.42542 15.3334 5.45127C15.3334 2.47711 12.9459 0.0666504 10.0001 0.0666504C7.05425 0.0666504 4.66675 2.47711 4.66675 5.45127C4.66675 8.42542 7.05425 10.8359 10.0001 10.8359ZM13.9917 12.2073L12.0001 20.259L10.6667 14.5378L12.0001 12.182H8.00008L9.33341 14.5378L8.00008 20.259L6.00841 12.2073C3.03758 12.3503 0.666748 14.8028 0.666748 17.8359V19.5859C0.666748 20.7007 1.56258 21.6051 2.66675 21.6051H17.3334C18.4376 21.6051 19.3334 20.7007 19.3334 19.5859V17.8359C19.3334 14.8028 16.9626 12.3503 13.9917 12.2073V12.2073Z" fill="black"/>
                </Svg>
                <div style={{ }}>
                  <Text style={{ fontSize: 14, marginBottom: '4px' }}>Gestor</Text>
                  <Text style={{ fontSize: 10 }}>Gestor direto do AVALIADO, a quem ele responde no organograma.</Text>
                </div>
              </div>}

              {model.participantes.some(e => e === 2) && <div style={{ display: 'flex', flexWrap: 'nowrap', flexDirection: 'row', fontSize: 14, alignItems: 'center', gap: '8px' }}>
                <Svg width="24" height="22" viewBox="0 0 24 22" fill="none">
                  <Path d="M4 5.93331C4.52742 5.93331 5.04299 5.77691 5.48152 5.4839C5.92005 5.19088 6.26185 4.7744 6.46368 4.28713C6.66551 3.79986 6.71832 3.26369 6.61543 2.7464C6.51253 2.22912 6.25856 1.75397 5.88562 1.38103C5.51268 1.00809 5.03752 0.75411 4.52024 0.651216C4.00296 0.548322 3.46678 0.601131 2.97951 0.802965C2.49224 1.0048 2.07576 1.34659 1.78275 1.78512C1.48973 2.22365 1.33333 2.73923 1.33333 3.26664C1.33333 3.97389 1.61429 4.65216 2.11438 5.15226C2.61448 5.65236 3.29276 5.93331 4 5.93331ZM4 13.27C3.99941 13.0208 4.04948 12.7741 4.14718 12.5449C4.24488 12.3157 4.38817 12.1088 4.56833 11.9366L7.57375 9.09998C7.6425 9.03539 7.73083 9.00373 7.8075 8.95123C7.61141 8.45482 7.27068 8.0288 6.8295 7.72841C6.38833 7.42803 5.86706 7.26715 5.33333 7.26664H2.66667C1.95942 7.26664 1.28115 7.54759 0.781049 8.04769C0.280952 8.54779 0 9.22607 0 9.93331L0 13.9333C0 14.2869 0.140476 14.6261 0.390524 14.8761C0.640573 15.1262 0.979711 15.2666 1.33333 15.2666V20.6C1.33333 20.9536 1.47381 21.2927 1.72386 21.5428C1.97391 21.7928 2.31304 21.9333 2.66667 21.9333H5.33333C5.68696 21.9333 6.02609 21.7928 6.27614 21.5428C6.52619 21.2927 6.66667 20.9536 6.66667 20.6V16.5837L4.56833 14.6033C4.38811 14.4312 4.24479 14.2243 4.14708 13.9951C4.04937 13.7659 3.99933 13.5192 4 13.27V13.27ZM20 5.93331C20.5274 5.93331 21.043 5.77691 21.4815 5.4839C21.9201 5.19088 22.2618 4.7744 22.4637 4.28713C22.6655 3.79986 22.7183 3.26369 22.6154 2.7464C22.5125 2.22912 22.2586 1.75397 21.8856 1.38103C21.5127 1.00809 21.0375 0.75411 20.5202 0.651216C20.003 0.548322 19.4668 0.601131 18.9795 0.802965C18.4922 1.0048 18.0758 1.34659 17.7827 1.78512C17.4897 2.22365 17.3333 2.73923 17.3333 3.26664C17.3333 3.97389 17.6143 4.65216 18.1144 5.15226C18.6145 5.65236 19.2928 5.93331 20 5.93331ZM21.3333 7.26664H18.6667C18.133 7.26712 17.6118 7.42793 17.1706 7.72824C16.7294 8.02855 16.3887 8.45448 16.1925 8.95081C16.2692 9.00373 16.3592 9.03414 16.4267 9.10039L19.4317 11.9362C19.6113 12.1087 19.7542 12.3158 19.8518 12.5449C19.9494 12.774 19.9998 13.0205 19.9998 13.2696C19.9998 13.5186 19.9494 13.7651 19.8518 13.9942C19.7542 14.2233 19.6113 14.4304 19.4317 14.6029L17.3333 16.5841V20.6C17.3333 20.9536 17.4738 21.2927 17.7239 21.5428C17.9739 21.7928 18.313 21.9333 18.6667 21.9333H21.3333C21.687 21.9333 22.0261 21.7928 22.2761 21.5428C22.5262 21.2927 22.6667 20.9536 22.6667 20.6V15.2666C23.0203 15.2666 23.3594 15.1262 23.6095 14.8761C23.8595 14.6261 24 14.2869 24 13.9333V9.93331C24 9.22607 23.719 8.54779 23.219 8.04769C22.7189 7.54759 22.0406 7.26664 21.3333 7.26664V7.26664ZM18.5167 12.9058L15.5117 10.07C15.4407 10.0024 15.3515 9.95708 15.2551 9.93975C15.1586 9.92243 15.0592 9.93383 14.9692 9.97254C14.8791 10.0113 14.8025 10.0756 14.7487 10.1575C14.6949 10.2394 14.6664 10.3353 14.6667 10.4333V11.9333H9.33333V10.4333C9.3337 10.3353 9.30523 10.2393 9.25149 10.1573C9.19774 10.0753 9.12108 10.011 9.03103 9.97221C8.94099 9.93344 8.84154 9.92201 8.74505 9.93932C8.64856 9.95663 8.55929 10.0019 8.48833 10.0696L5.48333 12.9058C5.38728 13.0026 5.33338 13.1334 5.33338 13.2698C5.33338 13.4061 5.38728 13.5369 5.48333 13.6337L8.48833 16.47C8.55931 16.5376 8.64863 16.5829 8.74515 16.6002C8.84168 16.6175 8.94117 16.6061 9.03123 16.5672C9.12129 16.5284 9.19794 16.464 9.25166 16.382C9.30538 16.2999 9.33378 16.2039 9.33333 16.1058V14.6H14.6667V16.1058C14.6662 16.2039 14.6946 16.2999 14.7483 16.382C14.8021 16.464 14.8787 16.5284 14.9688 16.5672C15.0588 16.6061 15.1583 16.6175 15.2548 16.6002C15.3514 16.5829 15.4407 16.5376 15.5117 16.47L18.5167 13.6337C18.6127 13.5369 18.6666 13.4061 18.6666 13.2698C18.6666 13.1334 18.6127 13.0026 18.5167 12.9058V12.9058Z" fill="black"/>
                </Svg>

                <div style={{ }}>
                  <Text style={{ fontSize: 14, marginBottom: '4px' }}>Pares</Text>
                  <Text style={{ fontSize: 10 }}>Colaboradores com o mesmo nível de responsabilidade, de outro ou mesmo departamento do AVALIADO.</Text>
                </div>
              </div>}

              {model.participantes.some(e => e === 3) && <div style={{ display: 'flex', flexWrap: 'nowrap', flexDirection: 'row', fontSize: 14, alignItems: 'center', gap: '8px' }}>
                <Svg width="24" height="18" viewBox="0 0 24 18" fill="none">
                  <Path d="M3.6 7.94762C4.92375 7.94762 6 6.86924 6 5.54286C6 4.21648 4.92375 3.1381 3.6 3.1381C2.27625 3.1381 1.2 4.21648 1.2 5.54286C1.2 6.86924 2.27625 7.94762 3.6 7.94762ZM20.4 7.94762C21.7238 7.94762 22.8 6.86924 22.8 5.54286C22.8 4.21648 21.7238 3.1381 20.4 3.1381C19.0763 3.1381 18 4.21648 18 5.54286C18 6.86924 19.0763 7.94762 20.4 7.94762ZM21.6 9.15H19.2C18.54 9.15 17.9438 9.41678 17.5088 9.84889C19.02 10.6793 20.0925 12.1785 20.325 13.9595H22.8C23.4638 13.9595 24 13.4222 24 12.7571V11.5548C24 10.2284 22.9238 9.15 21.6 9.15ZM12 9.15C14.3213 9.15 16.2 7.26753 16.2 4.94167C16.2 2.61582 14.3213 0.733337 12 0.733337C9.67875 0.733337 7.8 2.61582 7.8 4.94167C7.8 7.26753 9.67875 9.15 12 9.15ZM14.88 10.3524H14.5688C13.7888 10.7281 12.9225 10.9536 12 10.9536C11.0775 10.9536 10.215 10.7281 9.43125 10.3524H9.12C6.735 10.3524 4.8 12.2912 4.8 14.681V15.7631C4.8 16.7588 5.60625 17.5667 6.6 17.5667H17.4C18.3938 17.5667 19.2 16.7588 19.2 15.7631V14.681C19.2 12.2912 17.265 10.3524 14.88 10.3524ZM6.49125 9.84889C6.05625 9.41678 5.46 9.15 4.8 9.15H2.4C1.07625 9.15 0 10.2284 0 11.5548V12.7571C0 13.4222 0.53625 13.9595 1.2 13.9595H3.67125C3.9075 12.1785 4.98 10.6793 6.49125 9.84889Z" fill="black"/>
                </Svg>
                <div style={{ }}>
                  <Text style={{ fontSize: 14, marginBottom: '4px' }}>Liderados</Text>
                  <Text style={{ fontSize: 10 }}>Colaboradores que respondem direto para o AVALIADO (o avaliado é gestor do colaborador).</Text>
                </div>
              </div>}

              {model.participantes.some(e => e === 4) && <div style={{ display: 'flex', flexWrap: 'nowrap', flexDirection: 'row', fontSize: 14, alignItems: 'center', gap: '8px' }}>
                <Svg width="24" height="18" viewBox="0 0 24 18" fill="none">
                  <Path d="M7.2 8.99998C9.52125 8.99998 11.4 7.12123 11.4 4.79998C11.4 2.47873 9.52125 0.599976 7.2 0.599976C4.87875 0.599976 3 2.47873 3 4.79998C3 7.12123 4.87875 8.99998 7.2 8.99998ZM10.08 10.2H9.76875C8.98875 10.575 8.1225 10.8 7.2 10.8C6.2775 10.8 5.415 10.575 4.63125 10.2H4.32C1.935 10.2 0 12.135 0 14.52V15.6C0 16.5937 0.80625 17.4 1.8 17.4H12.6C13.5938 17.4 14.4 16.5937 14.4 15.6V14.52C14.4 12.135 12.465 10.2 10.08 10.2ZM18 8.99998C19.9875 8.99998 21.6 7.38748 21.6 5.39998C21.6 3.41248 19.9875 1.79998 18 1.79998C16.0125 1.79998 14.4 3.41248 14.4 5.39998C14.4 7.38748 16.0125 8.99998 18 8.99998ZM19.8 10.2H19.6575C19.1363 10.38 18.585 10.5 18 10.5C17.415 10.5 16.8638 10.38 16.3425 10.2H16.2C15.435 10.2 14.73 10.4212 14.1112 10.7775C15.0262 11.7637 15.6 13.0725 15.6 14.52V15.96C15.6 16.0425 15.5813 16.1212 15.5775 16.2H22.2C23.1938 16.2 24 15.3937 24 14.4C24 12.0787 22.1213 10.2 19.8 10.2Z" fill="black"/>
                </Svg>
                <div style={{ }}>
                  <Text style={{ fontSize: 14, marginBottom: '4px' }}>Outros</Text>
                  <Text style={{ fontSize: 10 }}>Colaboradores de outros departamentos, como clientes internos ou nomenclatura diferente mas que mantém contato direto com o AVALIADO.</Text>
                </div>
              </div>}

              {model.participantes.some(e => e === 6) && <div style={{ display: 'flex', flexWrap: 'nowrap', flexDirection: 'row', fontSize: 14, alignItems: 'center', gap: '8px' }}>
                <Svg width="24" height="18" viewBox="0 0 24 18" fill="none">
                  <Path d="M7.2 8.99998C9.52125 8.99998 11.4 7.12123 11.4 4.79998C11.4 2.47873 9.52125 0.599976 7.2 0.599976C4.87875 0.599976 3 2.47873 3 4.79998C3 7.12123 4.87875 8.99998 7.2 8.99998ZM10.08 10.2H9.76875C8.98875 10.575 8.1225 10.8 7.2 10.8C6.2775 10.8 5.415 10.575 4.63125 10.2H4.32C1.935 10.2 0 12.135 0 14.52V15.6C0 16.5937 0.80625 17.4 1.8 17.4H12.6C13.5938 17.4 14.4 16.5937 14.4 15.6V14.52C14.4 12.135 12.465 10.2 10.08 10.2ZM18 8.99998C19.9875 8.99998 21.6 7.38748 21.6 5.39998C21.6 3.41248 19.9875 1.79998 18 1.79998C16.0125 1.79998 14.4 3.41248 14.4 5.39998C14.4 7.38748 16.0125 8.99998 18 8.99998ZM19.8 10.2H19.6575C19.1363 10.38 18.585 10.5 18 10.5C17.415 10.5 16.8638 10.38 16.3425 10.2H16.2C15.435 10.2 14.73 10.4212 14.1112 10.7775C15.0262 11.7637 15.6 13.0725 15.6 14.52V15.96C15.6 16.0425 15.5813 16.1212 15.5775 16.2H22.2C23.1938 16.2 24 15.3937 24 14.4C24 12.0787 22.1213 10.2 19.8 10.2Z" fill="black"/>
                </Svg>
                <div style={{ }}>
                  <Text style={{ fontSize: 14, marginBottom: '4px' }}>Alta liderança</Text>
                  <Text style={{ fontSize: 10 }}>Colaboradores com o nível de liderança elevado dentro da organização.</Text>
                </div>
              </div>}
              <div style={{ color: 'red', display: 'flex', flexWrap: 'nowrap', flexDirection: 'row', fontSize: 12, alignItems: 'center', gap: '8px' }}>
                <Text style={{ fontSize: 10 }}>Para garantir a confidencialidade dos grupos, nas Vertentes de Pares e Liderados, caso haja menos de 3 pessoas, os resultados são agrupados na vertente Outros.</Text>
              </div>
            </View>
          </View>
        </View>

        <View>
          <View
            style={{
              width: '100%',
              backgroundColor: '#1961E0',
              flexDirection: 'column',
              color: 'white',
              paddingVertical: 48,
              gap: 12,
              paddingHorizontal: 32
            }}
          >
            <Text style={{ fontSize: 16, textAlign: 'center' }}>Critérios da avaliação</Text>
            {model.participantes.some(e => e === 0) && <View style={{ fontSize: 11 }}>
              <Text style={{ marginBottom: 8 }}>Para essa avaliação, cada stakeholder é convidado a destacar</Text>
              <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', gap: '6px', alignItems: 'center', marginBottom: '4px' }}>
                <View style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', backgroundColor: 'white', height: 24, width: 24 }}>{ObterIcone2({ selo: 4, stake: 0 })}</View>
                <Text>{model.qtdEscolhas} {isCobb
                  ? 'competências consideradas os maiores destaques positivos do avaliado para o seu crescimento profissional'
                  : 'competências consideradas como destaques positivos do avaliado na função atual'}</Text>
              </View>
              <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', gap: '6px', alignItems: 'center' }}>
                <View style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', backgroundColor: 'white', height: 24, width: 24 }}>{ObterIcone2({ selo: 1, stake: 0 })}</View>
                <Text>{model.qtdEscolhas} {isCobb
                  ? 'competências consideradas prioridades de desenvolvimento do avaliado para o seu crescimento profissional'
                  : 'competências consideradas maiores prioridades de desenvolvimento do avaliado na função atual'}</Text>
              </View>
            </View>}

            <View style={{ fontSize: 11 }}>
              <Text style={{ marginBottom: 8 }}>Além dessas, foi utilizada mais dois tipos de indicações para as autoavaliações, onde o avaliado indicou</Text>
              <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', gap: '6px', alignItems: 'center', marginBottom: '4px' }}>
                <View style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', backgroundColor: 'white', height: 24, width: 24 }}>{ObterIcone2({ selo: 2, stake: 0 })}</View>
                <Text>{model.qtdEscolhas} competências que mais o motiva, quando as aplica</Text>
              </View>
              <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', gap: '6px', alignItems: 'center' }}>
                <View style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', backgroundColor: 'white', height: 24, width: 24 }}>{ObterIcone2({ selo: 3, stake: 0 })}</View>
                <Text>{model.qtdEscolhas} competências que menos o motiva, quando as aplica</Text>
              </View>
            </View>
          </View>
        </View>
        <Footer nomeAvaliado={model.avaliado.nome} nomePesquisa={model.nomePesquisa} numeroPagina={GetPage(3)}/>
      </Page>}

      {MostrarCompetencias && <Page style={styles.DefaultPage}>
        <Header />
        <View style={{ padding: 32, flex: 1 }}>
          <View style={{ display: 'flex', justifyContent: 'center' }}>
            <Text
              style={{
                textAlign: 'center',
                fontSize: 24,
                fontFamily: 'Roboto',
                fontWeight: 'bold',
                paddingBottom: '32px',
                color: '#000000'
              }}
            >
              Competências utilizadas
            </Text>
          </View>
          <View style={{ display: 'flex', gap: 32 }}>
            {ArrayToChunks(model.competencias.filter(e => !e.discursiva), 3).map(e => {
              return (<View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: 32, alignItems: 'center', flexWrap: 'nowrap' }}>
                {e.map(comp => {
                  return (<View style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <View style={{ height: '48px', width: '48px' }}>
                      <PDFImage style={{ objectFit: 'contain' }} src={ObterIcone(comp.icone)}/>
                    </View>
                    <Text style={{ fontSize: '12px' }}>{comp.nome}</Text>
                  </View>)
                })}
              </View>)
            })}
          </View>
        </View>
        <Footer nomeAvaliado={model.avaliado.nome} nomePesquisa={model.nomePesquisa} numeroPagina={GetPage(4)}/>
      </Page>}

      {model.tabelaAvaliacoes2 && <Page style={styles.DefaultPage}>
        <Header />
        <View style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', gap: '12px' }}>
            <Text
              style={{
                fontSize: 24,
                fontFamily: 'Roboto',
                fontWeight: 'bold',
                paddingTop: '32px',
                color: '#000000',
                marginBottom: '-12px',
                paddingHorizontal: 32
              }}
            >
              Competências
            </Text>
            <Text
              style={{
                fontSize: 24,
                fontFamily: 'Roboto',
                fontWeight: 'bold',
                paddingBottom: '10px',
                color: '#000000',
                paddingHorizontal: 32
              }}
            >
              Intensidade na percepções dos stakeholders
            </Text>
          </View>
        <View style={{ paddingHorizontal: 32, flex: 1 }}>
          <View>
            <Text style={{ fontSize: 10 }}>
              Resultante da quantidade de indicações por vertentes de Stakeholders de cada competência, nesta pesquisa cada Vertente tinha o mesmo peso e, cada Stakeholder selecionou 2 competências como destaque e 2 competências como pontos de atenção. Neste gráfico a nota máxima é +1 e a nota mínima -1. Exemplo caso você não tenha tido nenhuma indicação em determinada competência ela irá aparecer 0,00.
            </Text>
          </View>

          {Grafico
            ? (
            <PDFImage
              src={Grafico}
              style={{ marginTop: 8 }}
            />
              )
            : null}

          <View style={{ flexDirection: 'column', marginTop: 16 }}>
            {ArrayToChunks(valorOrdenado, 2).map((linha, indexLinha) => (
              <View
                key={indexLinha}
                style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 10 }}
              >
                {linha.map((e, i) => (
                  <Text
                    key={`${indexLinha}-${i}`}
                    // Duas colunas iguais usando flex
                    style={{ flexGrow: 1, flexBasis: 0, fontSize: 10, marginRight: i === 0 ? 12 : 0 }}
                  >
                    {`C${i + 1 + indexLinha * 2}. ${e.nome} (${e.media})`}
                  </Text>
                ))}
                {/* Se vier só 1 item na última linha, preenche o espaço da 2a coluna para manter alinhamento */}
                {linha.length === 1 && <View style={{ flexGrow: 1, flexBasis: 0 }} />}
              </View>
            ))}
          </View>
        </View>

        <Footer nomeAvaliado={model.avaliado.nome} nomePesquisa={model.nomePesquisa} numeroPagina={GetPage(5)}/>
      </Page>}
      {model.tabelaAvaliacoes2 && <Page style={styles.DefaultPage}>
        <Header />
        <View style={{ display: 'flex', justifyContent: 'center' }}>
          <Text
            style={{
              textAlign: 'center',
              fontSize: 24,
              fontFamily: 'Roboto',
              fontWeight: 'bold',
              paddingVertical: '32px',
              color: '#000000'
            }}
          >
            Resultados
          </Text>
        </View>
        <View style={{ paddingHorizontal: 32, flex: 1 }}>
          {RetornarTabela()}
          <View style={{ fontSize: 10, marginTop: '16px' }}>
              <View style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexDirection: 'row', marginBottom: '8px' }}>
                  <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center' }}>{ObterIcone2({ selo: 4, stake: 0 })} <Text>Considera ser um destaque positivo</Text></div>
                  <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center' }}>{ObterIcone2({ selo: 1, stake: 0 })}  <Text>Considera ter mais necessidade de desenvolvimento</Text></div>
              </View>
              <View style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexDirection: 'row' }}>
                  <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center' }}>{ObterIcone2({ selo: 2, stake: 0 })}  <Text>Que você mais se motiva</Text></div>
                  <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center' }}>{ObterIcone2({ selo: 3, stake: 0 })}  <Text>Que você menos se motiva</Text></div>
              </View>
          </View>
        </View>
        <Footer nomeAvaliado={model.avaliado.nome} nomePesquisa={model.nomePesquisa} numeroPagina={GetPage(6)}/>
      </Page>}

      {model.discursivas.length > 0 && model.comentariosRelatorio && <Page style={styles.DefaultPage}>
        <Header />
        <View style={{ padding: 32, flex: 1 }}>
          <View style={{ display: 'flex', justifyContent: 'center' }}>
            <Text
              style={{
                textAlign: 'center',
                fontSize: 24,
                fontWeight: 'bold',
                fontFamily: 'Roboto',
                paddingBottom: '32px',
                color: '#000000'
              }}
            >
              Comentários
            </Text>
          </View>
          <View style={{ display: 'flex', gap: 8 }}>
            {model.discursivas.map(e => {
              return (<View style={{ display: 'flex', padding: 12, backgroundColor: '#F0F0F0' }}>
                <Text style={{ fontSize: 12 }}>{e}</Text>
              </View>)
            })}
          </View>
        </View>
        <Footer nomeAvaliado={model.avaliado.nome} nomePesquisa={model.nomePesquisa} numeroPagina={GetPage(7)}/>
      </Page>}

      {model.resumoCompetencias && model.resumoCompetencias.length > 0 &&
        <Page style={styles.DefaultPage}>
          <Header />
          <View style={{ padding: 32, flex: 1 }}>
            <View style={{ display: 'flex', justifyContent: 'center' }}>
              <Text
                style={{
                  textAlign: 'center',
                  fontSize: 24,
                  fontFamily: 'Roboto',
                  fontWeight: 'bold',
                  paddingBottom: '32px',
                  color: '#000000'
                }}
              >
                Conclusões
              </Text>
            </View>
            {model.resumoCompetencias.filter(e => e.status === 1).length > 0 && <View style={{ display: 'flex', gap: '16px', padding: 8 }}>
              <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'flex-start', gap: 8 }}>
                {ObterIcone2({ selo: 4, stake: 0 })}
                <Text style={{ fontSize: 16, color: '#27AE60' }}>Competências avaliadas pelos seus stakeholders como seus pontos fortes</Text>
              </View>
              {model.resumoCompetencias.filter(e => e.status === 1).map((item) => {
                return (<View style={{ display: 'flex', flexDirection: 'row', gap: 12 }}>
                  <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center', gap: '12px' }}>
                    <View style={{ display: 'flex', gap: 6, justifyContent: 'center', alignItems: 'center' }}>
                      <PDFImage style={{ objectFit: 'contain', height: '56px' }} src={ObterIcone(item.avatar)}/>
                      <Text style={{ fontSize: 10, width: '84px', textAlign: 'center' }}>{item.nome}</Text>
                    </View>
                    <Text style={{ fontSize: 11, fontFamily: 'Roboto', fontWeight: 'bold', maxWidth: '410px' }}>Descrição: {item.descricao}</Text>
                  </View>
                </View>)
              })}
            </View>}
            {model.resumoCompetencias.filter(e => e.status === 2).length > 0 && <View style={{ display: 'flex', gap: '16px', padding: 8, marginTop: 16 }}>
              <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'flex-start', gap: 8 }}>
                {ObterIcone2({ selo: 2, stake: 0 })}
                <Text style={{ fontSize: 16, color: '#2F80ED' }}>Competências que mais o motivam, quando aplicadas</Text>
              </View>
              {model.resumoCompetencias.filter(e => e.status === 2).map((item) => {
                return (<View style={{ display: 'flex', flexDirection: 'row', gap: 12 }}>
                  <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center', gap: '12px' }}>
                    <View style={{ display: 'flex', gap: 6, justifyContent: 'center', alignItems: 'center' }}>
                      <PDFImage style={{ objectFit: 'contain', height: '56px' }} src={ObterIcone(item.avatar)}/>
                      <Text style={{ fontSize: 10, width: '84px', textAlign: 'center' }}>{item.nome}</Text>
                    </View>
                    <Text style={{ fontSize: 11, fontFamily: 'Roboto', fontWeight: 'bold', maxWidth: '410px' }}>Descrição: {item.descricao}</Text>
                  </View>
                </View>)
              })}
            </View>}
          </View>
          <Footer nomeAvaliado={model.avaliado.nome} nomePesquisa={model.nomePesquisa} numeroPagina={GetPage(8)}/>
        </Page>
      }

      {model.resumoCompetencias && model.resumoCompetencias.length > 0 &&
        <Page style={styles.DefaultPage}>
          <Header />
          <View style={{ padding: 32, flex: 1 }}>
            <View style={{ display: 'flex', justifyContent: 'center' }}>
              <Text
                style={{
                  textAlign: 'center',
                  fontSize: 24,
                  fontFamily: 'Roboto',
                  fontWeight: 'bold',
                  paddingBottom: '32px',
                  color: '#000000'
                }}
              >
                Conclusões
              </Text>
            </View>
            {model.resumoCompetencias.filter(e => e.status === 0).length > 0 && <View style={{ display: 'flex', gap: '12px', padding: 8 }}>
              <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'flex-start', gap: 8 }}>
                {ObterIcone2({ selo: 1, stake: 0 })}
                <Text style={{ fontSize: 16, color: '#F2994A' }}>Competências avaliadas pelos seus stakeholders como prioridade para seu desenvolvimento profissional</Text>
              </View>
              {model.resumoCompetencias.filter(e => e.status === 0).map((item) => {
                return (<View style={{ display: 'flex', flexDirection: 'row', gap: 12 }}>
                  <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center', gap: '12px' }}>
                    <View style={{ display: 'flex', gap: 6, justifyContent: 'center', alignItems: 'center' }}>
                      <PDFImage style={{ objectFit: 'contain', height: '56px' }} src={ObterIcone(item.avatar)}/>
                      <Text style={{ fontSize: 10, width: '84px', textAlign: 'center' }}>{item.nome}</Text>
                    </View>
                    <View style={{ display: 'flex', gap: 4 }}>
                      <Text style={{ fontSize: 11, fontFamily: 'Roboto', fontWeight: 'bold', maxWidth: '410px' }}>Descrição: {item.descricao}</Text>
                      <Text style={{ fontSize: 11, maxWidth: '410px' }}>{item.pergunta}</Text>
                    </View>
                  </View>
                </View>)
              })}
            </View>}

            {model.resumoCompetencias.filter(e => e.status === 3).length > 0 && <View style={{ display: 'flex', gap: '9px', padding: 8, marginTop: 16 }}>
              <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'flex-start', gap: 6 }}>
                {ObterIcone2({ selo: 3, stake: 0 })}
                <Text style={{ fontSize: 16, color: '#66046B' }}>Competências que menos o motivam, quando aplicadas</Text>
              </View>
              <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'nowrap', maxWidth: '87%' }}>
                {model.resumoCompetencias.filter(e => e.status === 3).map((item) => {
                  return (<View style={{ display: 'flex', flexDirection: 'row', gap: 12, width: '40%' }}>
                    <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center', gap: '12px' }}>
                      <View style={{ display: 'flex', gap: 6, justifyContent: 'center', alignItems: 'center', minWidth: '70px' }}>
                        <PDFImage style={{ objectFit: 'contain', height: '56px' }} src={ObterIcone(item.avatar)}/>
                        <Text style={{ fontSize: 11, width: '70px', textAlign: 'center' }}>{item.nome}</Text>
                      </View>
                      <Text style={{ fontSize: 11, fontFamily: 'Roboto', fontWeight: 'bold', width: '160px', textAlign: 'justify' }}>Descrição: {item.descricao}</Text>
                    </View>
                  </View>)
                })}
              </View>
            </View>}

            {model.resumoCompetencias.filter(e => e.status === 4).length > 0 && <View style={{ display: 'flex', gap: '9px', padding: 8, marginTop: 16 }}>
              <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'flex-start', gap: 6 }}>
                <PDFImage style={{ objectFit: 'contain', width: '32px', maxHeight: '16px' }} src={'https://sigah.blob.core.windows.net/onboard/icones/Vector 3_00dcf32e-dfeb-40a6-8269-a3cd804a999b.png'}/>
                <Text style={{ fontSize: 16, color: '#828282' }}>Outras oportunidades de desenvolvimento</Text>
              </View>
              <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'nowrap', maxWidth: '87%' }}>
                {model.resumoCompetencias.filter(e => e.status === 4).map((item) => {
                  return (<View style={{ display: 'flex', flexDirection: 'row', gap: 12, width: '40%' }}>
                    <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center', gap: '12px' }}>
                      <View style={{ display: 'flex', gap: 6, justifyContent: 'center', alignItems: 'center', minWidth: '70px' }}>
                        <PDFImage style={{ objectFit: 'contain', height: '56px' }} src={ObterIcone(item.avatar)}/>
                        <Text style={{ fontSize: 11, width: '70px', textAlign: 'center' }}>{item.nome}</Text>
                      </View>
                      <Text style={{ fontSize: 11, fontFamily: 'Roboto', fontWeight: 'bold', width: '160px', textAlign: 'justify' }}>Descrição: {item.descricao}</Text>
                    </View>
                  </View>)
                })}
              </View>
            </View>}
          </View>
          <Footer nomeAvaliado={model.avaliado.nome} nomePesquisa={model.nomePesquisa} numeroPagina={GetPage(9)}/>
        </Page>
      }

      {MostrarRecomendacoes && model.acoes && ArrayToChunks(model.acoes, 3).map((e, i) => {
        return (
          <Page style={styles.DefaultPage}>
            <Header />
            <View style={{ padding: 32, flex: 1 }}>
              <View style={{ display: 'flex', justifyContent: 'center' }}>
                <Text
                  style={{
                    textAlign: 'center',
                    fontSize: 24,
                    fontFamily: 'Roboto',
                    fontWeight: 'bold',
                    paddingBottom: '32px',
                    color: '#000000'
                  }}
                >
                  Recomendações
                </Text>
              </View>
              <View style={{ display: 'flex', gap: '16px', padding: 8 }}>
                {e.map((acao, index) => {
                  return (<View style={{ display: 'flex', padding: 8, gap: 8, backgroundColor: '#F0F0F0' }}>
                    <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center' }}>
                      <PDFImage style={{ objectFit: 'contain', height: '32px' }} src={ObterIcone(acao.icone)}/>
                      <Text style={{ fontSize: 12 }}>Ação {i * 3 + index + 1}: {acao.acao}</Text>
                    </View>
                    <View style={{ display: 'flex' }}>
                      <Text style={{ fontSize: 11, fontFamily: 'Roboto', fontWeight: 'bold' }}>O que fazer:</Text>
                      <Text style={{ fontSize: 11 }}>{acao.oqueFazer}</Text>
                    </View>
                    <View style={{ display: 'flex' }}>
                      <Text style={{ fontSize: 11, fontFamily: 'Roboto', fontWeight: 'bold' }}>Como fazer:</Text>
                      <Text style={{ fontSize: 11 }}>{acao.comoFazer}</Text>
                    </View>
                    {/* <View style={{ display: 'flex' }}>
                      <Text style={{ fontSize: 12, fontFamily: 'Roboto', fontWeight: 'bold' }}>Por que fazer:</Text>
                      <Text style={{ fontSize: 12 }}>{acao.porqueFazer}</Text>
                    </View> */}
                  </View>)
                })}
              </View>
            </View>
            <Footer nomeAvaliado={model.avaliado.nome} nomePesquisa={model.nomePesquisa} numeroPagina={GetPage(10 + i)}/>
          </Page>
        )
      })}

      <Page style={{ flexDirection: 'column' }}>
        <View style={{ paddingHorizontal: 32, flex: 1 }}>
          <View style={{ display: 'flex', justifyContent: 'center' }}>
            <Text
              style={{
                textAlign: 'center',
                fontSize: 24,
                fontFamily: 'Roboto',
                fontWeight: 'bold',
                paddingTop: '54px',
                paddingBottom: '32px',
                color: '#66046B'
              }}
            >
              {model.nomePesquisa}
            </Text>
          </View>
          <View style={{ display: 'flex', flexDirection: 'row', gap: 16, flexWrap: 'nowrap', alignItems: 'center' }}>
            <PDFImage
              style={{ objectFit: 'contain', maxWidth: '140px', maxHeight: '140px' }}
              src={ObterLogo()}
            />
            <Text style={{ fontSize: 14, maxWidth: 370, textAlign: 'justify' }}>
              {model.avaliado.nome}, a cada passo em direção ao desenvolvimento, você se aproxima do topo da montanha do sucesso. Use este relatório como mapa para escalar com segurança e alcançar seus objetivos.
            </Text>
          </View>
        </View>
        <View>
          <PDFImage
            style={{ objectFit: 'contain', maxWidth: '100%', maxHeight: '500px' }}
            src={'https://sigah.blob.core.windows.net/onboard/icones/Group 521 %287%29_ec746cce-7c91-465c-9d64-012b2c0bb574.png'}
          />
        </View>
      </Page>
    </Document>
  )
}
